import { useEffect, useState } from 'react'
import { animate, motion, useTransform } from 'framer-motion'

import { ISkill } from '@/src/types/candidateSkills.type'
import { getColorByPercent } from '@/src/helpers/getColorByPercent'

import styles from '../CandidateSkills.module.css'

export const Skill = ({ skill_title, skill_value }: ISkill) => {
  const [prevValue, setPrevValue] = useState(0)
  const rounded = useTransform(() => Math.round(prevValue))

  useEffect(() => {
    const controls = animate(prevValue, skill_value, { duration: 0.5 })
    setPrevValue(skill_value)

    return () => {
      controls.stop()
    }
  }, [skill_value, prevValue])

  return (
    <li className={styles?.skillItem}>
      <h5 className={styles?.skillTitle}>{skill_title}</h5>

      <div className={styles?.skillValue}>
        <motion.div
          className={styles?.bar}
          initial={{ right: '100%' }}
          animate={{
            right: `${100 - rounded?.get()}%`,
            backgroundColor: getColorByPercent(rounded?.get()),
          }}
        />
      </div>

      <span className={styles?.skillValueNumber}>{skill_value}</span>
    </li>
  )
}
